var $5550add6e102aded$exports = {};
document.addEventListener("DOMContentLoaded", ()=>{
    const videoBackground = document.querySelector(".video-background");
    const video = videoBackground.querySelector("video");
    if (video) video.addEventListener("loadeddata", ()=>{
        videoBackground.classList.add("loaded");
    });
});


//# sourceMappingURL=index.58a8bbd2.js.map
